// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing051({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle10
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/051/25010301.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/051/25010302.jpg`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/051/25010303.jpg`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/consultButton.png`}
      companyName="본원"
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori2.jpg`}
      eventDates={true}
    />
  );
}

export default Randing051;
